import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IEmptyCartIconProps {
    className?: string;
}

const EmptyCartIcon = (props: IEmptyCartIconProps) => {
    const className = classNames('elc-empty-cart-icon', props.className);
    const image = `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' %3E%3Cpath d='M4.06189375,7 C4.55399184,3.05368842 7.92038235,0 12,0 C16.0796177,0 19.4460082,3.05368842 19.9381062,7 L24,7 L24,24 L0,24 L0,7 L4.06189375,7 Z M6.08295844,7 L17.9170416,7 C17.4409635,4.16228666 14.9729963,2 12,2 C9.02700371,2 6.55903653,4.16228666 6.08295844,7 Z M2,9 L2,22 L22,22 L22,9 L2,9 Z' id='path-1' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { EmptyCartIcon };
